class Review {
  constructor() {
    this.reviewBtn = document.querySelector(".review-btn");
    this.inputField = document.querySelectorAll(".form-control");
    this.rating__checkbox = document.querySelectorAll(".rating__checkbox");
    this.email_pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    this.reviewDataObj = {
      psr_cust_fname: "",
      psr_cust_lname: "",
      psr_prod_feedback: "",
      psr_prod_rating: "",
      psr_status: "N",
      psr_date_added: "",
      psr_source: "Animigo",
      psr_prod_rating_total: "",
      review_image: "",
    };

    this.initialize();
  }

  initialize() {
    this.reviewBtn.addEventListener("click", (evt) =>
      this.handleReviewSubmit(evt)
    );
    this.inputField.forEach((item, index) => {
      item.addEventListener("keyup", (evt) => {
        let inputValue = evt.target.value;
        let inputType = evt.target.type;
        console.log(inputType);
        inputValue = inputValue.trim();
        inputValue == 0
          ? evt.target
              .closest(".field")
              .querySelector(".error-message")
              .classList.remove("hidden")
          : evt.target
              .closest(".field")
              .querySelector(".error-message")
              .classList.add("hidden");
        if (
          inputType == "email" &&
          this.email_pattern.test(evt.target.value) == false
        ) {
          evt.target
            .closest(".field")
            .querySelector(".error-message")
            .classList.remove("hidden");
        }
        this.reviewDataObj[evt.target.name] = evt.target.value;
      });
    });

    this.rating__checkbox.forEach((item, index) => {
      item.addEventListener("click", (evt) => {
        document.querySelector(".review-error").classList.add("hidden");
      });
    });
  }

  getFormattedDate() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  handleReviewSubmit(evt) {
    evt.preventDefault();
    this.reviewDataObj.psr_cust_fname = document.querySelector("#firstName").value || document.querySelector("#firstnameErr").classList.remove("hidden");
    this.reviewDataObj.psr_cust_lname = document.querySelector("#lastName").value || document.querySelector("#lastnameErr").classList.remove("hidden");
    this.reviewDataObj.psr_cust_email = document.querySelector("#ContactForm-email").value || document.querySelector("#email").classList.remove("hidden");
    this.reviewDataObj.psr_prod_feedback = document.querySelector("#reviewMessage").value || document.querySelector(".feedback_error").classList.remove("hidden");
    this.reviewDataObj.psr_date_added = this.getFormattedDate();
    this.reviewDataObj.psr_source = "Animigo";

    let width = document.querySelector(".rating__filled-stars").getAttribute("style") || document.querySelector(".review-error").classList.remove("hidden");
    if (width == null || width == undefined) return;
    width = width.split(":")[1].split("%")[0].trim();

    this.reviewDataObj.psr_prod_rating_total = width / 10;
    if (width <= 60) {
      this.reviewDataObj.psr_status = "N";
      this.reviewDataObj.psr_prod_rating = width / 20;
    } else {
      this.reviewDataObj.psr_status = "Y";
      this.reviewDataObj.psr_prod_rating = width / 20;
    }

    this.reviewDataObj.review_star_Image = `https://assets.animigo.co.uk/assets/animigo/images/svg/star-${this.reviewDataObj.psr_prod_rating}.svg`;
    
    let formData = new FormData();
    let fileInput = document.getElementById("reviewImage");

    if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
      console.error("No file selected.");
    } else {
      let file = fileInput.files[0];
      formData.append("file", file);
    }

   if (this.reviewDataObj) {
      try {
        formData.append("reviewData", JSON.stringify(this.reviewDataObj));
      } catch (error) {
        console.error("Error serializing reviewDataObj:", error.message);
      }
    } else {
      console.error("reviewDataObj is undefined.");
  }


    let grecaptchaWrapper = document.querySelector('.g-recaptcha');
        if(grecaptchaWrapper){
            if(grecaptcha.getResponse().length == 0){
                grecaptchaWrapper.nextElementSibling.classList.remove('hidden');
                return ;
            }else{
                grecaptchaWrapper.nextElementSibling.classList.add('hidden');
            }
        }
    let objStatus = this.checkObjectFields(this.reviewDataObj);

    if (objStatus) {
      const loaderDiv = document.querySelector(".loader_div");
      if (loaderDiv) {
        loaderDiv.classList.remove("hidden");
      }
        this.fetchRequest(formData, this.reviewDataObj);
    }
  }

 fetchRequest(formData, reviewData) {
    // Retrieve the product ID or any other necessary data dynamically if needed
    const productId = document.getElementById("product--id").value;

    // Define the API endpoint
    const apiUrl = "https://shopify-app-722384162149.us-central1.run.app/api/review";

    fetch(apiUrl, {
        method: "POST", 
        headers: {
        "Content-Type": "application/json", // Specify JSON content type
        }, 
        body: JSON.stringify({ reviewData, productId }), 
    })
        .then((response) => {
            // Check if the response is successful
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json(); // Parse JSON from the response
        })
        .then((responseData) => {
            // Handle the successful response
            console.log("Success:", responseData);
            const loaderDiv = document.querySelector(".loader_div");
            if (loaderDiv) {
                loaderDiv.classList.add("hidden");
            }
            if (responseData.status === "ok") {

               const reviewPopup = document.querySelector("#review-form-popup");
                if (reviewPopup) {
                    reviewPopup.classList.add("hidden"); // Add the hidden class
                    console.log("Popup hidden successfully"); // Debugging log
                    setTimeout(() => {
                        alert('Thank you for submitting your review!');
                    }, 1000);
                } else {
                    console.error("Element #review-form-popup not found");
                }
              // console.log(document.querySelector("#review-form-popup")); 
              // document.querySelector("#review-form-popup").addClass("hidden");
              // setTimeout(() => {
              //   alert('Thank you for submitting your review!');
              //   }, 3000);
              
                // document.querySelector("#success-msg_popup").classList.remove("hidden");
                // setTimeout(() => {
                //     document.querySelector("#success-msg_popup").classList.add("hidden");
                // }, 3000);

                // alert('Thank you for submitting your review!');
              
            } 
        })
        .catch((error) => {
            // Handle any errors that occurred during the fetch
            console.error("Fetch error:", error);
            const loaderDiv = document.querySelector(".loader_div");
            if (loaderDiv) {
                loaderDiv.classList.add("hidden");
            }
        });
}    

  checkObjectFields(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && key !== "review_image") {
        if (obj[key] === "" || obj[key] === null || obj[key] === undefined) {
          return false; // Return false if any field (except review_image) is empty
        }
      }
    }
    return true; // All fields (except review_image) contain values
  }
}

function closePopup(){
  document.querySelector("#success-msg_popup").classList.add("hidden");
}
// Instantiate the Review class
const review = new Review();
